import { render } from "./Index.vue?vue&type=template&id=4b0ce247&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-4b0ce247"

export default script